import type { KeyTextField } from '@prismicio/client';
import { memo } from 'react';

import { SloppingLines } from '@/assets';
import styles from './contentMessage.module.scss';

interface ContentMessageProps {
  content: KeyTextField;
  author: KeyTextField;
}

const ContentMessageComponent = ({ author, content }: ContentMessageProps) => {
  return (
    <div className={styles.message_wrapper}>
      <SloppingLines />
      <div>
        <p>{content}</p>
        <p className={styles.author}>{author}</p>
      </div>
    </div>
  );
};
export const ContentMessage = memo(ContentMessageComponent);
